import React from "react";
import styled from "styled-components";
import imgTeal from "../../assets/Layout/hamburger-teal.png";
import imgDark from "../../assets/Layout/hamburger.png";
import imgLight from "../../assets/Layout/hamburger-lite.png";

const HamburgerIcon = styled.img`
  height: 1.35rem;
  margin: 0.375rem 0;
  width: 1.333rem;
  cursor: pointer;
`;

export default ({ color = "dark", toggleMenuVisibility }) => {
  const src =
    {
      teal: imgTeal,
      white: imgLight
    }[color] || imgDark;
  return <HamburgerIcon src={src} onClick={() => toggleMenuVisibility(true)} />;
};



// WEBPACK FOOTER //
// ./src/components/MenuIcon.js